module.exports = __webpack_public_path__ + "img/hotel-17.d342604d.jpeg";